import { z } from 'zod';
/** The tree parents, in navigation order. */
export const SERVICE_PARENTS = [
    { code: 'TRANSFERS_ROOT', nameAr: 'الحوالات', nameEn: 'Transfers' },
    { code: 'NEW_TRANSFER_ROOT', nameAr: 'حوالة جديدة', nameEn: 'New transfer' },
    { code: 'SUPERVISION_ROOT', nameAr: 'الإشراف', nameEn: 'Supervision' },
    { code: 'BOXES_ROOT', nameAr: 'الصناديق', nameEn: 'Boxes' },
    { code: 'BANK_ACCOUNTS_ROOT', nameAr: 'الحسابات البنكية', nameEn: 'Bank accounts' },
    { code: 'BALANCES_ROOT', nameAr: 'الأرصدة', nameEn: 'Balances' },
    { code: 'TIERS_ROOT', nameAr: 'شرائح العمولة', nameEn: 'Commission tiers' },
    { code: 'REPORTS_ROOT', nameAr: 'التقارير', nameEn: 'Reports' },
    { code: 'SETTINGS_ROOT', nameAr: 'إعدادات الحوالات', nameEn: 'Transfer settings' },
    { code: 'USERS_ROOT', nameAr: 'المستخدمين', nameEn: 'Users' },
    { code: 'GROUPS_ROOT', nameAr: 'المجموعات', nameEn: 'Groups' },
];
const ROWS = [
    ['TRANSFER_LIST', 'TRANSFER', 'TRANSFERS_ROOT', 'عرض قائمة الحوالات', 'List transfers'],
    ['TRANSFER_VIEW', 'TRANSFER', 'TRANSFERS_ROOT', 'عرض تفاصيل الحوالة', 'View transfer'],
    ['TRANSFER_EXPORT', 'TRANSFER', 'TRANSFERS_ROOT', 'تصدير الحوالات', 'Export transfers'],
    ['TRANSFER_REPRINT', 'TRANSFER', 'TRANSFERS_ROOT', 'إعادة طباعة الإيصال', 'Reprint receipt'],
    ['TRANSFER_RESEND', 'TRANSFER', 'TRANSFERS_ROOT', 'إعادة إرسال الرسالة', 'Resend message'],
    ['TRANSFER_CREATE', 'TRANSFER', 'NEW_TRANSFER_ROOT', 'إنشاء حوالة', 'Create transfer'],
    ['TRANSFER_UPDATE', 'TRANSFER', 'SUPERVISION_ROOT', 'تعديل الحوالة', 'Edit transfer'],
    ['TRANSFER_CANCEL', 'TRANSFER', 'SUPERVISION_ROOT', 'إلغاء الحوالة', 'Cancel transfer'],
    ['BOX_LIST', 'BOX', 'BOXES_ROOT', 'عرض قائمة الصناديق', 'List boxes'],
    ['BOX_VIEW', 'BOX', 'BOXES_ROOT', 'عرض تفاصيل الصندوق', 'View box'],
    ['BOX_CREATE', 'BOX', 'BOXES_ROOT', 'إضافة صندوق', 'Create box'],
    ['BOX_UPDATE', 'BOX', 'BOXES_ROOT', 'تعديل الصندوق', 'Update box'],
    ['BOX_CHANGE_STATUS', 'BOX', 'BOXES_ROOT', 'تغيير حالة الصندوق', 'Change box status'],
    ['BOX_DELETE', 'BOX', 'BOXES_ROOT', 'حذف الصندوق', 'Delete box'],
    [
        'BANK_ACCOUNT_LIST',
        'BANK_ACCOUNT',
        'BANK_ACCOUNTS_ROOT',
        'عرض قائمة الحسابات البنكية',
        'List bank accounts',
    ],
    [
        'BANK_ACCOUNT_VIEW',
        'BANK_ACCOUNT',
        'BANK_ACCOUNTS_ROOT',
        'عرض تفاصيل الحساب البنكي',
        'View bank account',
    ],
    [
        'BANK_ACCOUNT_CREATE',
        'BANK_ACCOUNT',
        'BANK_ACCOUNTS_ROOT',
        'إضافة حساب بنكي',
        'Create bank account',
    ],
    [
        'BANK_ACCOUNT_UPDATE',
        'BANK_ACCOUNT',
        'BANK_ACCOUNTS_ROOT',
        'تعديل الحساب البنكي',
        'Update bank account',
    ],
    [
        'BANK_ACCOUNT_CHANGE_STATUS',
        'BANK_ACCOUNT',
        'BANK_ACCOUNTS_ROOT',
        'تغيير حالة الحساب البنكي',
        'Change bank account status',
    ],
    [
        'BANK_ACCOUNT_DELETE',
        'BANK_ACCOUNT',
        'BANK_ACCOUNTS_ROOT',
        'حذف الحساب البنكي',
        'Delete bank account',
    ],
    [
        'BALANCE_ADJUST',
        'BALANCE',
        'BALANCES_ROOT',
        'إضافة وسحب رصيد',
        'Add and withdraw balance',
        ['BOX_LIST', 'BOX_VIEW', 'BANK_ACCOUNT_LIST', 'BANK_ACCOUNT_VIEW'],
    ],
    [
        'BALANCE_MOVE',
        'BALANCE',
        'BALANCES_ROOT',
        'نقل رصيد',
        'Move balance',
        ['BOX_LIST', 'BOX_VIEW', 'BANK_ACCOUNT_LIST', 'BANK_ACCOUNT_VIEW'],
    ],
    ['TIER_LIST', 'TIER', 'TIERS_ROOT', 'عرض شرائح العمولة', 'List commission tiers'],
    ['TIER_VIEW', 'TIER', 'TIERS_ROOT', 'عرض تفاصيل الشريحة', 'View commission tier'],
    ['TIER_CREATE', 'TIER', 'TIERS_ROOT', 'إضافة شريحة', 'Create commission tier'],
    ['TIER_UPDATE', 'TIER', 'TIERS_ROOT', 'تعديل الشريحة', 'Update commission tier'],
    [
        'TIER_CHANGE_STATUS',
        'TIER',
        'TIERS_ROOT',
        'تغيير حالة الشريحة',
        'Change commission tier status',
    ],
    ['TIER_DELETE', 'TIER', 'TIERS_ROOT', 'حذف الشريحة', 'Delete commission tier'],
    ['REPORT_VIEW', 'REPORT', 'REPORTS_ROOT', 'عرض التقارير', 'View reports'],
    ['REPORT_EXPORT', 'REPORT', 'REPORTS_ROOT', 'تصدير التقارير', 'Export reports'],
    ['SETTINGS_VIEW', 'SETTINGS', 'SETTINGS_ROOT', 'عرض إعدادات الحوالات', 'View transfer settings'],
    [
        'SETTINGS_UPDATE',
        'SETTINGS',
        'SETTINGS_ROOT',
        'تعديل إعدادات الحوالات',
        'Update transfer settings',
    ],
    ['USER_LIST', 'USER', 'USERS_ROOT', 'عرض قائمة المستخدمين', 'List users'],
    ['USER_VIEW', 'USER', 'USERS_ROOT', 'عرض تفاصيل المستخدم', 'View user'],
    ['USER_CREATE', 'USER', 'USERS_ROOT', 'إضافة مستخدم', 'Create user'],
    ['USER_UPDATE', 'USER', 'USERS_ROOT', 'تعديل المستخدم', 'Update user'],
    ['USER_CHANGE_STATUS', 'USER', 'USERS_ROOT', 'تغيير حالة المستخدم', 'Change user status'],
    ['USER_RESET_PASSWORD', 'USER', 'USERS_ROOT', 'إعادة تعيين كلمة المرور', 'Reset password'],
    ['USER_DELETE', 'USER', 'USERS_ROOT', 'حذف المستخدم', 'Delete user'],
    ['GROUP_LIST', 'GROUP', 'GROUPS_ROOT', 'عرض قائمة المجموعات', 'List groups'],
    ['GROUP_VIEW', 'GROUP', 'GROUPS_ROOT', 'عرض تفاصيل المجموعة', 'View group'],
    ['GROUP_CREATE', 'GROUP', 'GROUPS_ROOT', 'إضافة مجموعة', 'Create group'],
    ['GROUP_UPDATE', 'GROUP', 'GROUPS_ROOT', 'تعديل المجموعة', 'Update group'],
    ['GROUP_CHANGE_STATUS', 'GROUP', 'GROUPS_ROOT', 'تغيير حالة المجموعة', 'Change group status'],
    ['GROUP_DELETE', 'GROUP', 'GROUPS_ROOT', 'حذف المجموعة', 'Delete group'],
    ['GROUP_SERVICE_MANAGE', 'GROUP', 'GROUPS_ROOT', 'تعيين خدمات المجموعة', 'Assign group services'],
];
const CODES = new Set(ROWS.map(([code]) => code));
function defaultDependencies(code, entity) {
    const list = `${entity}_LIST`;
    const view = `${entity}_VIEW`;
    if (code === list)
        return [];
    if (code === view)
        return CODES.has(list) ? [list] : [];
    return [list, view].filter((c) => CODES.has(c));
}
export const SERVICE_CATALOG = ROWS.map(([code, entity, parentCode, nameAr, nameEn, deps]) => ({
    code,
    entity,
    parentCode,
    nameAr,
    nameEn,
    dependsOn: deps ?? defaultDependencies(code, entity),
}));
export const SERVICE_CODES = ROWS.map(([code]) => code);
export const serviceCodeSchema = z.string().refine((v) => CODES.has(v), 'unknown service code');
/**
 * Every code a selection implies, transitively (SH-08, SH-09). Unknown codes
 * are dropped.
 */
export function serviceClosure(selected) {
    const byCode = new Map(SERVICE_CATALOG.map((s) => [s.code, s]));
    const result = new Set();
    const stack = selected.filter((c) => byCode.has(c));
    while (stack.length > 0) {
        const code = stack.pop();
        if (result.has(code))
            continue;
        result.add(code);
        for (const dep of byCode.get(code)?.dependsOn ?? [])
            stack.push(dep);
    }
    return [...result].toSorted();
}
/**
 * Seeded groups (transfers.md section 10). مدير النظام is the built-in system
 * group holding every service; it cannot be deleted or emptied (SH-10).
 */
export const SEEDED_GROUPS = [
    {
        key: 'SYSTEM_ADMIN',
        nameAr: 'مدير النظام',
        nameEn: 'System administrator',
        services: SERVICE_CODES,
    },
    {
        key: 'BRANCH_EMPLOYEE',
        nameAr: 'موظف الفرع',
        nameEn: 'Branch employee',
        services: serviceClosure([
            'TRANSFER_CREATE',
            'TRANSFER_LIST',
            'TRANSFER_VIEW',
            'TRANSFER_REPRINT',
            'TRANSFER_RESEND',
        ]),
    },
    {
        key: 'REPORTS_USER',
        nameAr: 'مستخدم تقارير',
        nameEn: 'Reports user',
        services: serviceClosure([
            'TRANSFER_LIST',
            'TRANSFER_VIEW',
            'TRANSFER_EXPORT',
            'REPORT_VIEW',
            'REPORT_EXPORT',
        ]),
    },
];
//# sourceMappingURL=contract.js.map